// 全局鉴权补丁：为全部 /api/ 与 /cms/api/ 请求自动附加 Bearer token（2026-09-03 安全加固扩量）
// （原为服务器手工 patch dist，现写入源码随构建保留）
(function () {
  if (window.__cmsAuthFetchPatched) return
  var _f = window.fetch
  window.__cmsAuthFetchPatched = true
  window.fetch = function (url, opts) {
    try {
      if (typeof url === 'string') {
        var m = /\/(?:cms\/)?api\//.test(url)
        if (m) {
          opts = opts || {}
          opts.headers = opts.headers || {}
          var hasAuth = ('Authorization' in opts.headers) || ('authorization' in opts.headers)
          if (!hasAuth) {
            var t = ''
            try {
              t = localStorage.getItem('cms_token') || (JSON.parse(localStorage.getItem('cms_user') || '{}').token) || ''
            } catch (e) {}
            if (t) opts.headers.Authorization = 'Bearer ' + t
          }
        }
      }
    } catch (e) {}
    return _f.call(this, url, opts)
  }
})()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
